import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { ColorPickerModule } from "ngx-color-picker";

import { SharedModule } from "../dashboard/shared/shared.module";
import { AbsenceModalComponent } from "./absence-modal/absence-modal.component";
import { AddClipboardItemComponent } from "./add-clipboard-item/add-clipboard-item.component";
import { AddOrganizationModalComponent } from "./add-organization-modal/add-organization-modal.component";
import { AddPlayerModalComponent } from "./add-player-modal/add-player-modal.component";
import { AddProjectModalComponent } from "./add-project-modal/add-project-modal.component";
import { AddSickLeaveComponent } from "./add-sick-leave/add-sick-leave.component";
import { AssignPlayersLocalModalComponent } from "./assign-players-local-modal/assign-players-local-modal.component";
import { AssignPlayersModalComponent } from "./assign-players-modal/assign-players-modal.component";
import { AssignProjectsModalComponent } from "./assign-projects-modal/assign-projects-modal.component";
import { CancelPlanModalComponent } from "./cancel-plan-modal/cancel-plan-modal.component";
import { ClipboardPopupComponent } from "./clipboard-popup/clipboard-popup.component";
import { ConfirmationModalComponent } from "./confirmation-modal/confirmation-modal.component";
import { DeletePlayerModalComponent } from "./delete-player-modal/delete-player-modal.component";
import { EditPlayerModalComponent } from "./edit-player-modal/edit-player-modal.component";
import { EditProjectModalComponent } from "./edit-project-modal/edit-project-modal.component";
import { HolidaysModalComponent } from "./holidays-modal/holidays-modal.component";
import { IncomeModalComponent } from "./income-modal/income-modal.component";
import { OrgSetHoursModalComponent } from "./org-set-hours-modal/org-set-hours-modal.component";
import { PdfTimelineDatepickerModalComponent } from "./pdf-timeline-datepicker-modal/pdf-timeline-datepicker-modal.component";
import { PieChartComponent } from "./player-profile-modal/pie-chart/pie-chart.component";
import { PlayerProfileModalComponent } from "./player-profile-modal/player-profile-modal.component";
import { PlayerRateModalComponent } from "./player-rate-modal/player-rate-modal.component";
import { TimelineDatepickerComponent } from "./timeline-datepicker/timeline-datepicker.component";
import { TimeoutDateIntervalModalComponent } from "./timeout-date-interval-modal/timeout-date-interval-modal.component";
import { TimeoutRequestModalComponent } from "./timeout-request-modal/timeout-request-modal.component";
import { TrialExpiredModalComponent } from "./trial-expired-modal/trial-expired-modal.component";
import { UserVisibilityModalComponent } from "./user-visibility-modal/user-visibility-modal.component";
import { ViewEditModalComponent } from "./view-edit-modal/view-edit-modal.component";
import { WorkingHoursModalComponent } from "./working-hours-modal/working-hours-modal.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    ColorPickerModule,
    BsDatepickerModule.forRoot(),
    PieChartComponent,
    AddProjectModalComponent,
    AddPlayerModalComponent,
    AssignProjectsModalComponent,
    AssignPlayersModalComponent,
    HolidaysModalComponent,
    AbsenceModalComponent,
    WorkingHoursModalComponent,
    AddOrganizationModalComponent,
    AssignPlayersLocalModalComponent,
    ConfirmationModalComponent,
    EditProjectModalComponent,
    PlayerProfileModalComponent,
    TimeoutRequestModalComponent,
    PlayerRateModalComponent,
    IncomeModalComponent,
    AddClipboardItemComponent,
    OrgSetHoursModalComponent,
    TimelineDatepickerComponent,
    ClipboardPopupComponent,
    EditPlayerModalComponent,
    AddSickLeaveComponent,
    TimeoutDateIntervalModalComponent,
    DeletePlayerModalComponent,
    CancelPlanModalComponent,
    ViewEditModalComponent,
    TrialExpiredModalComponent,
    PdfTimelineDatepickerModalComponent,
    UserVisibilityModalComponent
  ]
})
export class ModalsModule {}
